import _slicedToArray from "@babel/runtime-corejs2/helpers/slicedToArray";
import { useId } from '@reach/auto-id';
import { useCallback } from 'react';
import { makeId } from '../../utils';
import { useControllable } from '../../hooks';
/**
 * See {@link https://www.w3.org/WAI/ARIA/apg/patterns/disclosure | APG}
 */
export function useDisclosure() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    id = _ref.id,
    openProp = _ref.open,
    _ref$defaultOpen = _ref.defaultOpen,
    defaultOpen = _ref$defaultOpen === void 0 ? false : _ref$defaultOpen,
    onOpenChange = _ref.onOpenChange;
  var genId = useId(id);
  var contentId = makeId('disclosure', genId);
  var _useControllable = useControllable({
      prop: openProp,
      defaultProp: defaultOpen,
      onChange: onOpenChange
    }),
    _useControllable2 = _slicedToArray(_useControllable, 2),
    open = _useControllable2[0],
    setOpen = _useControllable2[1];

  /* eslint-disable react-hooks/exhaustive-deps */
  var show = useCallback(function () {
    return setOpen(true);
  }, []);
  var close = useCallback(function () {
    return setOpen(false);
  }, []);
  var toggle = useCallback(function () {
    return setOpen(function (v) {
      return !v;
    });
  }, [open]);
  /* eslint-enable react-hooks/exhaustive-deps */

  var triggerProps = {
    'aria-controls': contentId,
    'aria-expanded': open,
    onClick: toggle
  };
  var contentProps = {
    id: contentId,
    hidden: !open
  };
  return {
    open: open,
    show: show,
    close: close,
    toggle: toggle,
    setOpen: setOpen,
    contentId: contentId,
    triggerProps: triggerProps,
    contentProps: contentProps
  };
}